import axios from 'axios';

const BASE_URL
    = location && (location.hostname === 'we.nowyu.com' || location.hostname === 'me.nowyu.com')
        ? `${location.protocol}//api.nowyu.com/v1`
        : 'http://localhost:8080/v1';

const INSTANCE = axios.create({ baseURL: BASE_URL });

function download(path, fileName) {
    return INSTANCE
        .get(path)
        .then((response) => {
            const mime = response.headers['content-type'];
            const data = response.data;

            return new Blob(
                [data],
                { type: mime },
            );
        })
        .then((blob) => {
            const anchor = document.createElement('a');
            const objectUrl = window.URL.createObjectURL(blob);

            anchor.href = objectUrl;
            anchor.download = fileName;
            anchor.click();

            window.URL.revokeObjectURL(objectUrl);
        });
}

export {
    INSTANCE as default,
    BASE_URL,
    download,
};



// WEBPACK FOOTER //
// ./src/utils/api.js